<template>
  <basic-container>
    <!-- 搜索 -->
    <div class="search-area">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" size="small">

        <el-form-item>
          <el-date-picker v-model="submitTime" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
            :clearable="false"></el-date-picker>
        </el-form-item>

        <el-form-item>
          <DynamicOption v-model="searchForm.appid" :placeholder="'全部渠道'" :singleSelect="true"
            :params="searchOptions" />
        </el-form-item>

        <!-- 状态 -->
        <el-form-item>
          <el-select v-model="searchForm.status" placeholder="全部状态" clearable>
            <el-option label="处理中" value="0"></el-option>
            <el-option label="已完成" value="1"></el-option>
            <el-option label="已关闭" value="2"></el-option>
          </el-select>
        </el-form-item>

        <!-- 全部产品类型 -->
        <el-form-item>
          <el-select v-model="searchForm.productId" placeholder="全部产品类型" clearable>
            <el-option v-for="item in clientTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- UID -->
        <el-form-item>
          <el-input v-model="searchForm.uid" placeholder="UID" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="handleAdd">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="handleEdit">修改</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table :cell-style="{ 'text-align': 'center' }" :header-cell-style="{ 'text-align': 'center' }"
      :max-height="tableHeight" v-loading="listLoading" element-loading-text="加载中" border :data="tableData"
      :row-style="{ height: '30px' }">
      <el-table-column type="radio" width="55">
        <template slot-scope="scope">
          <el-radio :label="scope.row.id" v-model="selectedRow" @change="handleRadioChange(scope.row)">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="appid" label="APPID" width="120"></el-table-column>
      <el-table-column prop="channelName" label="渠道名称" width="150"></el-table-column>
      <el-table-column prop="productName" label="产品类型" width="120"></el-table-column>
      <el-table-column prop="uid" label="UID" width="240"></el-table-column>
      <el-table-column prop="description" label="故障描述" width="200">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.description" placement="top">
            <span class="ellipsis-text">{{ scope.row.description }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="note" label="备注" width="200">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.note" placement="top">
            <span class="ellipsis-text">{{ scope.row.note }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }} </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="提交时间" width="180"></el-table-column>
      <el-table-column prop="createUser" label="提交人" width="120"></el-table-column>
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button size="mini" text type="primary" @click="handleDownload(scope.row)" v-if="scope.row.status === 1">
            下载
          </el-button>
          <el-button size="mini" text type="primary" @click="handleDetail(scope.row)" v-if="scope.row.status === 1">
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize"
        :layout="paginationLayout" :total="totalCount">
      </el-pagination>
    </div>

    <logDetailDialog ref="logDetailDialog" @close="closeDetailDialog" />
    <logEditDialog ref="logEditDialog" @saved="onSaved" />
  </basic-container>
</template>

<script>
import { getLogList } from '@/api/clientManageMent/logList'
import { getClientType } from '@/api/user/cancelUser'
import DynamicOption from "@/components/DynamicOption/index.vue";
import logDetailDialog from "@/views/clientManagement/logDetailDialog.vue";
import logEditDialog from "@/views/clientManagement/logEditDialog.vue";
export default {
  name: 'LogExport',
  components: {
    DynamicOption,
    logDetailDialog,
    logEditDialog,
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        appid: '',
        status: '',
        productId: '',
        uid: ''
      },
      submitTime: [],
      // 产品类型选项
      productTypes: [
        { label: '投屏', value: 'cast' },
        { label: '遥控器', value: 'remote' },
        { label: '其他', value: 'other' }
      ],
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      listLoading: false,
      tableHeight: 500,
      // 分页信息
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      pageNo: 1,
      pageSize: 10,
      pageSizeArr: [10, 20, 50, 100],
      paginationLayout: 'total, sizes, prev, pager, next, jumper',
      totalCount: 0,
      selectedRow: "",
      currentRow: {},
      // 客户端类型
      clientTypes: [],
      // 日期选择器配置
      // pickerOptions: {
      //   shortcuts: [{
      //     text: '最近一周',
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }, {
      //     text: '最近一个月',
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }, {
      //     text: '最近三个月',
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }]
      // },
      // 日期选择器配置
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }],
        // 选择范围不能超过30天
        onPick: ({ minDate, maxDate }) => {
          this.pickerMinDate = minDate ? new Date(minDate) : null
          if (this.pickerMinDate && maxDate) {
            const diffDays = Math.floor((new Date(maxDate) - this.pickerMinDate) / (1000 * 60 * 60 * 24))
            if (diffDays > 30) {
              this.$message.warning('选择时间范围不能超过30天')
            }
          }
        },
        disabledDate: (time) => {
          if (!this.pickerMinDate) return false
          const min = new Date(this.pickerMinDate.getTime() - 30 * 24 * 60 * 60 * 1000)
          const max = new Date(this.pickerMinDate.getTime() + 30 * 24 * 60 * 60 * 1000)
          return time.getTime() < min.getTime() || time.getTime() > max.getTime()
        }
      },
      // 记录已选的首日
      pickerMinDate: null,
    }
  },
  created() {
    // 设置默认时间为前七天到今天
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.submitTime = [
      this.formatDate(start),
      this.formatDate(end)
    ];

    this.getList()
    this.fetchClientTypes()
  },
  methods: {
    // 格式化日期为 yyyy-MM-dd 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 获取状态类型
    getStatusType(status) {
      const types = {
        0: 'warning',
        1: 'success',
        2: 'info'
      }
      return types[status] || 'info'
    },

    // 获取状态文本
    getStatusText(status) {
      const texts = {
        0: '获取中',
        1: '获取成功',
        2: '获取失败'
      }
      return texts[status] || '未知'
    },

    // 获取列表数据
    async getList() {
      this.loading = true
      this.listLoading = true
      try {
        const params = {
          ...this.searchForm,
          current: this.page.current,
          size: this.page.size
        }
        if (this.submitTime && this.submitTime.length === 2) {
          params.begindate = this.submitTime[0]
          params.enddate = this.submitTime[1]
        }
        console.log("查询参数为", params)
        const ans = await getLogList(params)
        const res = ans.data
        this.tableData = res.data.records
        this.page.total = res.data.total
        this.totalCount = res.data.total
        this.pageNo = res.data.current
        this.pageSize = res.data.size
      } catch (error) {
        console.error('获取列表失败：', error)
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
        this.listLoading = false
      }
    },

    // 搜索
    handleSearch() {
      this.page.current = 1
      this.getList()
    },

    /** 获取客户端类型 */
    async fetchClientTypes() {
      const { data } = await getClientType();
      console.log("获取客户端类型", data);
      this.clientTypes = data.data[0].children.map((item) => {
        return {
          label: item.dictValue,
          value: item.dictKey,
        };
      });
    },

    // 单选行切换
    handleRadioChange(row) {
      this.currentRow = row
    },

    // 新增
    handleAdd() {
      this.$refs.logEditDialog.open({ mode: 'create' })
    },

    // 修改
    handleEdit() {
      const row = this.tableData.find(item => item.id === this.selectedRow) || this.currentRow
      if (!row || !row.id) {
        this.$message.warning('请先选择一条记录')
        return
      }
      this.$refs.logEditDialog.open({ mode: 'edit', data: row })
    },

    // 对话框保存回调
    onSaved() {
      this.getList()
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val
      this.page.size = val
      this.getList()
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pageNo = val
      this.page.current = val
      this.getList()
    },

    handleDetail(val) {
      console.log(val)
      this.$refs.logDetailDialog.open(val)
    },

    // 关闭详情对话框
    closeDetailDialog() {
      // 可以在这里添加关闭对话框后的逻辑
      console.log('详情对话框已关闭')
    },

    // 下载日志文件
    handleDownload(row) {
      if (row.logfileurl) {
        // 如果有日志文件URL，直接下载
        window.open(row.logfileurl, '_blank')
      } else {
        this.$message.warning('该记录没有可下载的日志文件')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cancel-user-container {
  .ellipsis-text {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .search-area {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
}
</style>